import { createFileRoute } from '@tanstack/react-router'

import { RecurringExpenseDetailPage } from '@/pages/expenses/recurring/[id]/RecurringExpenseDetailPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/expenses/recurring/$id/',
)({
  component: RecurringExpenseDetailPage,
})
